import * as React from 'react';
import { Typography, Container, Stack, Box } from '@mui/material';

import { Head } from '../seo';

type ContentLayoutProps = {
  children: React.ReactNode;
  title?: string;
  actions?: React.ReactNode;
};

export const ContentLayout = ({ children, title, actions }: ContentLayoutProps) => {
  return (
    <>
      <Head title={title} />
      <Stack sx={{ py: 3 }} gap={3}>
        {title && (
          <Container maxWidth='lg' sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
            <Box display='flex' justifyContent='space-between' alignItems='center'>
              <Typography variant='h4' component='h1' fontWeight='600' color='text.primary'>
                {title}
              </Typography>
              {actions && (
                <Box display='flex' gap={2}>
                  {actions}
                </Box>
              )}
            </Box>
          </Container>
        )}
        <Container maxWidth='lg' sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
          {children}
        </Container>
      </Stack>
    </>
  );
};
